import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { usePopupState, bindTrigger, bindMenu } from 'material-ui-popup-state/hooks';
import { PrivilegedContext } from 'store/user';
import { ActionOption } from 'types';

type MoreVertMenuProps = {
  actionOptions: ActionOption[];
  id: number;
  context?: PrivilegedContext;
};

const MoreVertMenu: React.FC<MoreVertMenuProps> = ({ actionOptions = [], context, id = 0 }) => {
  const popupState = usePopupState({ variant: 'popover', popupId: `popup-menu-${id}` });
  const { onClick: onTrigger, ...bindTriggerProps } = bindTrigger(popupState);
  const bindMenuProps = bindMenu(popupState);

  const stopEventPropogation = (event: any) => {
    event?.preventDefault();
    event?.stopPropagation();
  };

  const handleMenuItemClick = (onClick: any) => (event: any) => {
    stopEventPropogation(event);
    onClick?.(event);
    popupState.toggle(event);
  };

  const handleIconClick = (event: any) => {
    stopEventPropogation(event);

    popupState.toggle(event);
  };

  const handleOnMenuClose = (event: any) => {
    popupState.toggle(event);

    stopEventPropogation(event);
  };

  return (
    <React.Fragment>
      <div style={{ textAlign: 'right', paddingRight: 16 }}>
        <IconButton {...bindTriggerProps} onClick={handleIconClick}>
          <MoreVertIcon />
        </IconButton>
      </div>
      <Menu
        {...bindMenuProps}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={handleOnMenuClose}
      >
        {actionOptions
          .filter(x => (x.isPrivileged ? !!context && x.isPrivileged(context) : true))
          .map(({ label, MenuItemProps }: any) => {
            return (
              <MenuItem
                key={label}
                id={String(id)}
                {...MenuItemProps}
                onClick={handleMenuItemClick(MenuItemProps.onClick)}
              >
                {label}
              </MenuItem>
            );
          })}
      </Menu>
    </React.Fragment>
  );
};

export default MoreVertMenu;
